var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"xtermWrapper",staticClass:"mt-3",attrs:{"id":"k8s-xterm"}},[_c('div',{staticStyle:{"min-height":"600px"},attrs:{"id":"xterm"}})])}
var staticRenderFns = []

export { render, staticRenderFns }